module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.a3f0509b.png";